import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";

//
import ImageUploadApi from "Services/ImageUpload";
import driverApi from "Services/Driver";

//
import { CUSTOM_CONSTANTS } from "Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewDriverDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { openDialog, handleClose, driverId, setCloseAllTabs, entityLabel = "Driver" } = props;
  const entityLabelLower = entityLabel.toLowerCase();

  const [data, setData] = useState([]);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsRow, setDocumentsRow] = useState([]);
   const [documentsInitialData, setDocumentsInitialData] = useState([]);
  //

  const handleCloseTabs = () => {
    dispatch(
      showSnackbar({
        message: `${entityLabel} Updated Successfully`,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      })
    );

    handleClose();
    setCloseAllTabs(true);
  };

  //

  const getDriverCompleteDetails = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(showSnackbar({
          message: `${entityLabel} Details Fetched Successfully`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        }));
        setData(res?.data?.data);
        setDriverDocumentsData(res?.data?.data?.driverDocumentsDetails);
       
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: `Failed to fetch ${entityLabelLower} details`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    if (validation) {
      driverApi
        .getDriverCompleteDetailsByDId(driverId)
        .then(onSuccess, onFailure);
    }
  };

  const getDriverDocumentsTypes = () => {
    dispatch(showLoader("Loading please wait..."));
  
    const onSuccess = (res) => {
      dispatch(hideLoader());
  
      if (res?.status === 200) {
        console.log(res?.data?.data);
        const documentTypes = Array.isArray(res?.data?.data)
          ? res?.data?.data
          : Array.isArray(res?.data?.data?.data)
          ? res?.data?.data?.data
          : [];

        setDocumentsInitialData(documentTypes);
     
      }
    };
  
    const onFailure = (err) => {
      dispatch(hideLoader());
  
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
  
      console.log("error fetch service area", err);
    };
  
    driverApi.getDocumentsTypes().then(onSuccess).catch(onFailure);
  };

  useEffect(() => {
    setData([]);
    setDriverDocumentsData([]);
    getDriverCompleteDetails();
    getDriverDocumentsTypes();
  }, [openDialog]);

  useEffect(() => {
    const documentTypes = Array.isArray(documentsInitialData)
      ? documentsInitialData
      : [];

    const uploadedDocuments = Array.isArray(driverDocumentsData)
      ? driverDocumentsData
      : [];

    const combinedArray = documentTypes.map((item1) => {
      const matchingDocument = uploadedDocuments.find((item2) => {
        return (
          item1?.documentType
            ?.toLowerCase()
            ?.replace(/[()]/g, "")
            ?.replace(/-/g, " ")
            ?.replace(/\s+/g, " ")
            ?.trim() ===
          item2?.documentType
            ?.toLowerCase()
            ?.replace(/[()]/g, "")
            ?.replace(/-/g, " ")
            ?.replace(/\s+/g, " ")
            ?.trim()
        );;
      });
      console.log(documentsInitialData)
      console.log(driverDocumentsData)
const documentId =matchingDocument && matchingDocument.documentPath !== "" ? "Uploaded" : "Not uploaded";
const documentPath = matchingDocument ? matchingDocument.documentPath  : "-";
const status = matchingDocument ? matchingDocument.documentPath ? matchingDocument.status :"NO DOCUMENT": "NO DOCUMENT";
const uploadedDocumentName = matchingDocument? matchingDocument?.uploadedDocumentName: "-";

      return {
        ...item1,
        documentId,
        file: documentPath,
        status,
        uploadedDocumentName,
      };
    });

    setDocumentsRow(combinedArray);
  }, [driverDocumentsData, documentsInitialData]);

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"md"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Confirm {entityLabel} Details
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <div className={classes.driverContainer}>
              <div className={classes.driverImage}>
                <img
                  src={data?.driverInfoDetails?.image ||"/assets/images/user/avatar.png"}
                  alt="Profile Image"
                  className={classes.profileImage}
                />
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Basic Information</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Username:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.userName}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Country Code:</div>
                  {data?.driverInfoDetails?.countryCode}
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Mobile Number:</div>
                  {data?.driverInfoDetails?.mobileNumber}
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Email:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.email}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Gender:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.gender}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Country:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.country}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Address:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.address}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Bank Account Number:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.bankAccountNumber}
                  </div>
                </div>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Service Details</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Service:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.serviceTypeId?.serviceName}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Service Type:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.serviceKind}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Vehicle Number:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Vehicle Model:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleModel}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{entityLabel} License Number:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.driverLicenseNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>License Expiry Date:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.licenseExpiryDate}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Vehicle Insurance Number:</div>

                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleInsuranceNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Insurance Expiry Date:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.insuranceExpiryDate}
                  </div>
                </div>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>{entityLabel} Documents</h2>
                <table className={classes.table}>
                  <thead className={classes.tableHeader}>
                    <tr>
                      <th className={classes.tableCell}>Document Type</th>
                      <th className={classes.tableCell}>Status</th>
                      <th className={classes.tableCell}>Approval Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentsRow.map((document, index) => (
                      <tr key={index} className={classes.tableRow}>
                        <td className={classes.tableCell}>
                          {document?.documentType}
                        </td>
                        
                        <td className={classes.tableCell}>
                          {document.documentId}
                        </td>
                        <td className={classes.tableCell}>{document.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Account Status</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Account Status:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.accountStatus === "ONBOARDING"
                      ? "Onboarding"
                      : data?.driverServiceDetails?.accountStatus === "APPROVED"
                      ? "Approved"
                      : data?.driverServiceDetails?.accountStatus === "BANNED"
                      ? "Banned"
                      : ""}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{entityLabel} Status:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.driverAccountStatus ===
                    "ACTIVE"
                      ? "Active"
                      : data?.driverServiceDetails?.driverAccountStatus ===
                        "DE_ACTIVE"
                      ? "Deactive"
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose} style={{ marginRight: "10px" }}>
                Back to Edit
              </Button>
            </section>
            <section className={classes.closeBtn}>
              <Button onClick={handleCloseTabs} style={{ marginRight: "10px" }}>
                Confirm & Close
              </Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreviewDriverDetails;
